/**
 * Viewmodel for an Invoice Summary
 */
export class InvoiceTotals {

    public subtotal : number = 0.0;
    
    public freight: number = 0.0;

    public fuelSurcharge: number = 0.0;

    public fees: number = 0.0;
    
    public tax : number = 0.0;
    
    public total : number = 0.0;
    
}
